import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import Image from "react-bootstrap/Image";

import { BrandName, TextConfig } from './AgencyConfig';
import { useEffect, useState } from 'react';

import './../App2.css'
import '../redesign-2025.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import StNavbar from '../components/StNavbar';
import StFooter from '../components/StFooter';
import '../theme-style.css';
import { SetSeo } from '../lib/common_funcs';
import { storeUtm } from '../lib/common_funcs';

function StAgency() {

	storeUtm();

	const [copied, setCopied] = useState(false);

	const copyMcpConfig = () => {
		navigator.clipboard.writeText(TextConfig.mcpConfig.snippet);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	const scrollToMyRef = (id) => {
		var ref = document.getElementById(id);
		setTimeout(function () {

			 ref.scrollIntoView({
				 behavior: "smooth",
				 block: "start",
			 });
		}, 1000);
	};

	useEffect(() => {
		AOS.init({
			duration: 800,
			once: true,
			easing: 'ease-out-cubic',
			offset: 50
		});

		const anchor = window.location.hash.slice(1);

		if (anchor) {
			const anchorEl = document.getElementById(anchor);
			if (anchorEl) {
				scrollToMyRef(anchor);
			}
		}
	}, []);

	const homepageSeo = {
		title: "TurboSteed for Developers: Build with Claude Code, Deploy via MCP",
		description: "Build client sites with Claude Code using MCP integration. Deploy static sites via CLI, manage content via API. No infrastructure headaches.",
		canonicalUrl: "https://turbosteed.com/developers-and-agencies",
		keywords: "Claude Code, MCP, web hosting, developer hosting, AI site builder, headless CMS, API hosting",
		ogTitle: "TurboSteed for Developers: Claude Code + MCP Integration",
		ogImage: "https://turbosteed.com/images/ts-social-share-creators.jpg",
	}

	const schemaMarkup = {
		  "@context": "https://schema.org",
		  "@type": "WebSite",
		  "url": "https://turbosteed.com",
		  "name": "TurboSteed - AI-Driven Web Hosting"
	};

	const allParams = {
		"seo": homepageSeo,
		"schema": schemaMarkup
	}

	return (
		<div className="ts-redesign">

			<SetSeo {...allParams} />

			<StNavbar />

			{/* Hero Section */}
			<header id="home" className="ts-hero">
				<div className="ts-hero-bg">
					<div className="ts-gradient-orb ts-orb-1"></div>
					<div className="ts-gradient-orb ts-orb-2"></div>
					<div className="ts-gradient-orb ts-orb-3"></div>
				</div>
				<div className="ts-grid-pattern"></div>

				<div className="container ts-hero-content">
					<div className="row align-items-center">
						<div className="col-lg-6" data-aos="fade-right">
							<span className="ts-pill-badge">For Developers & Agencies</span>
							<h1 className="ts-hero-title">
								<span className="ts-gradient-text">{TextConfig.heroTitle}</span>
							</h1>
							<p className="ts-hero-subtitle">{TextConfig.heroDescription}</p>
							<div className="ts-hero-cta">
								<a href="https://dashboard.turbosteed.com" className="ts-btn ts-btn-primary">
									Start Now
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</a>
								<a href="#how-it-works" className="ts-btn ts-btn-glass">
									Learn More
								</a>
							</div>
						</div>
						<div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
							<div className="ts-mcp-config-card">
								<div className="ts-mcp-header">
									<span className="ts-mcp-title">{TextConfig.mcpConfig.headline}</span>
									<button className="ts-copy-btn" onClick={copyMcpConfig} title="Copy to clipboard">
										{copied ? (
											<>
												<i className="fa fa-check"></i> Copied
											</>
										) : (
											<>
												<i className="fa fa-clipboard"></i> Copy
											</>
										)}
									</button>
								</div>
								<pre className="ts-code-snippet"><code>{TextConfig.mcpConfig.snippet}</code></pre>
							</div>
						</div>
					</div>
				</div>
			</header>

			<main className="main-content d-block">

				{/* How It Works Section */}
				<section id="how-it-works" className="ts-section ts-section-light">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">How It <span className="ts-text-gradient">Works</span></h2>
							<p className="ts-section-subtitle">Get started in four simple steps</p>
						</header>

						<div className="ts-how-it-works-grid">
							{TextConfig.howItWorks.map((step, index) => (
								<div className="ts-step-card" key={step.step} data-aos="fade-up" data-aos-delay={index * 100}>
									<div className="ts-step-number">{step.step}</div>
									<h3>{step.title}</h3>
									<p>{step.description}</p>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* Two Ways to Build Section */}
				<section className="ts-section ts-section-gradient-1">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">Two Ways to <span className="ts-text-gradient">Build</span></h2>
							<p className="ts-section-subtitle">Choose the approach that fits your workflow</p>
						</header>

						<div className="ts-persona-grid" style={{gridTemplateColumns: 'repeat(2, 1fr)'}}>
							{TextConfig.personas.map((persona, index) => (
								<div className="ts-persona-card" key={persona.usecase} data-aos="fade-up" data-aos-delay={index * 100}>
									<div className="ts-persona-icon">
										<i className={persona.icon + " fa-2x"} aria-hidden="true"></i>
									</div>
									<h3>{persona.usecase}</h3>
									<p>{persona.persona}</p>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* Client Benefits Section */}
				<section id="benefits" className="ts-section ts-section-light">
					<div className="container">
						<div className="ts-feature-showcase" data-aos="fade-up">
							<div className="ts-feature-content">
								<h2>Benefits for <span className="ts-text-gradient">your clients</span></h2>
								<p>Mobile app for day-to-day updates, no dashboard access required</p>
								<ul className="ts-feature-list">
									<li>View site analytics and usage</li>
									<li>Contact form Inbox</li>
									<li>Asset library access</li>
								</ul>
								<a href="/contactus" className="ts-btn ts-btn-primary">
									Contact Us
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</a>
							</div>
							<div className="ts-feature-image" data-aos="fade-left" data-aos-delay="200">
								<img src="AppDemo-v1.gif" alt="Mobile App Demo" style={{maxWidth: "300px"}} />
							</div>
						</div>
					</div>
				</section>

				{/* Deploy Section */}
				<section className="ts-section ts-section-gradient-2">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">Ditch server headaches. <span className="ts-text-gradient">Deploy in seconds</span></h2>
							<p className="ts-section-subtitle">Perfect for those who've had enough of frameworks, security issues, and VM maintenance</p>
						</header>

						<div className="row g-4 justify-content-center">
							<div className="col-md-5" data-aos="fade-up" data-aos-delay="100">
								<div className="ts-bento-card h-100">
									<div className="ts-bento-card-icon">
										<i className="fa fa-tv"></i>
									</div>
									<h3>No hardware or software management</h3>
									<p>We take care of managing hardware, storage, network, burst traffic and software.</p>
								</div>
							</div>
							<div className="col-md-5" data-aos="fade-up" data-aos-delay="200">
								<div className="ts-bento-card h-100">
									<div className="ts-bento-card-icon">
										<i className="fa fa-code"></i>
									</div>
									<h3>Build with your tools, host with us</h3>
									<p>Use Claude Code, your favorite framework, or plain HTML. Deploy via CLI or API.</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Features Section */}
				<section id="features" className="ts-section ts-section-light">
					<div className="container">
						<header className="ts-section-header" data-aos="fade-up">
							<h2 className="ts-section-title">Key Platform <span className="ts-text-gradient">Features</span></h2>
						</header>
						<div className="ts-bento-grid">
							{TextConfig.benefits.map((benefit, index) => (
								<div key={benefit.feature} className="ts-bento-card" data-aos="fade-up" data-aos-delay={index * 100}>
									<div className="ts-bento-card-icon">
										<i className={benefit.icon}></i>
									</div>
									<h3>{benefit.feature}</h3>
									<p>{benefit.value}</p>
									<a className="ts-read-more" href={benefit.readmeUrl} aria-label={benefit['aria-label']} target="_blank" rel="noopener noreferrer">
										Read more
										<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<path d="M5 12h14M12 5l7 7-7 7"/>
										</svg>
									</a>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* API Section */}
				<section className="ts-section ts-section-gradient-2">
					<div className="container">
						<div className="row g-4 align-items-center">
							<div className="col-lg-6" data-aos="fade-right">
								<h2 className="ts-section-title">API Access for <span className="ts-text-gradient">Automation</span></h2>
								<p className="ts-section-subtitle" style={{textAlign: 'left'}}>Automate site creation and management with our REST API</p>
								<ul className="ts-feature-list">
									<li>Programmatic site creation</li>
									<li>Content and asset management</li>
									<li>CMS schema and entry operations</li>
									<li>Form data retrieval</li>
									<li>CI/CD pipeline integration</li>
								</ul>
								<a href="/docs/rest-api.html" target="_blank" className="ts-btn ts-btn-primary" style={{marginTop: '1rem'}}>
									View API Docs
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</a>
							</div>
							<div className="col-lg-6" data-aos="fade-left">
								<div className="ts-cli-card">
									<h3>Install the CLI</h3>
									<div className="ts-cli-install" style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '1rem'}}>
										<code>{TextConfig.cliInstall.command}</code>
										<a href={TextConfig.cliInstall.npmUrl} target="_blank" rel="noopener noreferrer" className="ts-npm-link">
											<i className="fa fa-external-link"></i>
										</a>
									</div>
									<p className="mt-3" style={{color: 'var(--ts-gray)'}}>Deploy with one command, integrate into your CI/CD pipeline, or use the MCP server for Claude Code integration.</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* CTA Section */}
				<section className="ts-section ts-section-dark ts-cta-section">
					<div className="container">
						<div className="ts-cta-content" data-aos="fade-up">
							<h2>Ready to simplify client hosting?</h2>
							<p>Start building with Claude Code today</p>

							<div className="ts-cta-buttons">
								<a href="https://dashboard.turbosteed.com" className="ts-btn ts-btn-primary ts-btn-lg">
									Create Account
									<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14M12 5l7 7-7 7"/>
									</svg>
								</a>
								<a href="/contactus" className="ts-btn ts-btn-glass ts-btn-lg">
									Contact Us
								</a>
							</div>
						</div>
					</div>
				</section>

			</main>

			<StFooter />

		</div>
	);
}

export default StAgency;
